import actions from './actions';

const {
    ONBOARDING_KB_LIST_BEGIN,
    ONBOARDING_KB_LIST_SUCCESS,
    ONBOARDING_KB_LIST_ERR,
    ONBOARDING_KB_ADD_BEGIN,
    ONBOARDING_KB_ADD_SUCCESS,
    ONBOARDING_KB_ADD_ERR,
    ONBOARDING_KB_UPDATE_BEGIN,
    ONBOARDING_KB_UPDATE_SUCCESS,
    ONBOARDING_KB_UPDATE_ERR,
    ONBOARDING_KB_DELETE_BEGIN,
    ONBOARDING_KB_DELETE_SUCCESS,
    ONBOARDING_KB_DELETE_ERR,
    ONBOARDING_KB_SYNC_BEGIN,
    ONBOARDING_KB_SYNC_SUCCESS,
    ONBOARDING_KB_SYNC_ERR,
} = actions;

const initState = {
    list: [],
    total: 0,
    currentPage: 1,
    loading: false,
    adding: false,
    updating: false,
    deleting: false,
    syncing: false,
    error: null,
};

const OnboardingKbReducer = (state = initState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ONBOARDING_KB_LIST_BEGIN:
            return { ...state, loading: true, error: null };
        case ONBOARDING_KB_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: data?.data ?? [],
                total: data?.total ?? 0,
                currentPage: data?.current_page ?? 1,
            };
        case ONBOARDING_KB_LIST_ERR:
            return { ...state, loading: false, error: err };

        case ONBOARDING_KB_ADD_BEGIN:
            return { ...state, adding: true, error: null };
        case ONBOARDING_KB_ADD_SUCCESS:
            return { ...state, adding: false };
        case ONBOARDING_KB_ADD_ERR:
            return { ...state, adding: false, error: err };

        case ONBOARDING_KB_UPDATE_BEGIN:
            return { ...state, updating: true, error: null };
        case ONBOARDING_KB_UPDATE_SUCCESS:
            return { ...state, updating: false };
        case ONBOARDING_KB_UPDATE_ERR:
            return { ...state, updating: false, error: err };

        case ONBOARDING_KB_DELETE_BEGIN:
            return { ...state, deleting: true, error: null };
        case ONBOARDING_KB_DELETE_SUCCESS:
            return { ...state, deleting: false };
        case ONBOARDING_KB_DELETE_ERR:
            return { ...state, deleting: false, error: err };

        case ONBOARDING_KB_SYNC_BEGIN:
            return { ...state, syncing: true, error: null };
        case ONBOARDING_KB_SYNC_SUCCESS:
            return { ...state, syncing: false };
        case ONBOARDING_KB_SYNC_ERR:
            return { ...state, syncing: false, error: err };

        default:
            return state;
    }
};

export default OnboardingKbReducer;
